import { TblCol } from '../../../../core/table/table.types';
import { tblSpecAddColumn } from '../../../../core/table/spec';
import FormattedDateRenderer from '../../../../core/table/renderers/FormattedDateRenderer';
import { TblViewSpec } from '../../../../core/table/table-view.types';

export type ColKey =
    | ''
    | 'NPI'
    | 'FullName'
    | 'TaxonomyDesc'
    | 'Phone'
    | 'Fax'
    | 'Validated'
    | 'CEs'
    | 'FaxConsent'
    | 'ModifiedDate';

// column spec (map the keys to the column types)
export function providerListColumnSpec(): Map<ColKey, TblCol> {
    const map = new Map<ColKey, TblCol>();
    tblSpecAddColumn<ColKey>(map, 'NPI', {});
    tblSpecAddColumn<ColKey>(map, 'FullName', { title: 'Name' });
    tblSpecAddColumn<ColKey>(map, 'TaxonomyDesc', { title: 'Taxonomy' });
    tblSpecAddColumn<ColKey>(map, 'Phone', {});
    tblSpecAddColumn<ColKey>(map, 'Fax', {});
    tblSpecAddColumn<ColKey>(map, 'Validated', {});
    tblSpecAddColumn<ColKey>(map, 'CEs', { title: 'Facility' });
    tblSpecAddColumn<ColKey>(map, 'FaxConsent', { title: 'Fax Consent' });
    tblSpecAddColumn<ColKey>(map, 'ModifiedDate', { title: 'Last Processed', type: 'DATE' }, FormattedDateRenderer);
    return map;
}

// default view
export function providerListDefaultView(): TblViewSpec {
    return {
        key: '0',
        title: 'Default',
        sections: [
            {
                title: 'Provider',
                cols: ['NPI', 'FullName', 'TaxonomyDesc', 'Phone', 'Fax', 'Validated'],
            },
            {
                title: 'Usage',
                cols: ['CEs', 'FaxConsent', 'ModifiedDate'],
            },
        ],
        sortby: 'NPI',
    };
}
